import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { AdsHandlerActionTypes } from './adsHandler.types';
import adsHandlerActions from './adsHandler.actions';

function* fetchAdsPages() {
  const { token } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: '/api/v1/ads/pages',
    headers: {
      'x-brand': brand,
      'x-token': token,
    },
  };

  try {
    const response = yield call(api.multiAgents.get, request);
    yield put(adsHandlerActions.pages.success(response.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method fetchAdsPages', error);
    yield put(adsHandlerActions.pages.failure());
  }
}

function* fetchDrafts() {
  const { jwt: jwtToken, token } = yield select(state => state.auth);
  const { id: clientId } = yield select(state => state.summary);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: '/api/v1/campaign/retrieve/data',
    params: {
      hgToken: jwtToken,
      clientId,
      brand,
    },
    headers: {
      'x-brand': brand,
      'x-token': token,
    },
  };

  try {
    const response = yield call(api.multiAgents.get, request);
    yield put(adsHandlerActions.drafts.success(response.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method fetchDrafts', error);
    yield put(adsHandlerActions.drafts.failure());
  }
}

function* sagas() {
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST, fetchAdsPages);
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST, fetchDrafts);
}

export default sagas;
